export const properties = {
    apiUrl: "https://api-certifica-t.app",
    // apiUrl: "http://localhost:80",
    pinataBearer: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiJkMDMzZWVmOC0yZTcwLTRjZDctYjM1Yy1hZDVmYjg0YzUzZTUiLCJlbWFpbCI6ImF5ZW5zYTg1QGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJwaW5fcG9saWN5Ijp7InJlZ2lvbnMiOlt7ImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxLCJpZCI6IkZSQTEifSx7ImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxLCJpZCI6Ik5ZQzEifV0sInZlcnNpb24iOjF9LCJtZmFfZW5hYmxlZCI6ZmFsc2UsInN0YXR1cyI6IkFDVElWRSJ9LCJhdXRoZW50aWNhdGlvblR5cGUiOiJzY29wZWRLZXkiLCJzY29wZWRLZXlLZXkiOiI2NzYzMDY3ZjE2MDdmYmVkM2E2OSIsInNjb3BlZEtleVNlY3JldCI6IjA1N2Q2NTFlNGMxZDBkYjJjNTczZjQ4NWQ4ZDcwZjIzOGU3MzkxZjFlOGJkNWE4ZTdkNzBjNjAxYmYwN2FkMjEiLCJleHAiOjE3NjMwMzA1NzF9.LYA-FfOSINmxUbbAqTErT902YeCdJGfDscRiuiVJZPc",
    pinataApiKey: "6763067f1607fbed3a69",
    appUser: "app@certifica-t.app",
    // appPass: "app",
    appPass: "Crtifik-T-!98S",
    proofUHostWallet: "0x01d99975c3b879d3b892476c403c06170637ecBa",
    contractOwner: "0x311Ec24B114F70E3C6E7435a7c1943b990a8794A",
    certificatePrice: '13820000000000',
    pinataServer: 'https://rose-parental-galliform-245.mypinata.cloud/ipfs/',
    pinataGateway: "rose-parental-galliform-245.mypinata.cloud",
    noMailValue: "undefined",
    rootUserRol: "ROOT",
    networkId: 137,
    web3Provider: "https://polygon-bor-rpc.publicnode.com",
    // web3Provider: "https://rpc-amoy.polygon.technology",
    // clientApp: "http://localhost:3000",
    //  adminApp: "http://localhost:3000",
    clientApp: "https://certifica-t.app",
    adminApp: "https://admin-certifica-t.app",
};